import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { UserAppointmentService } from 'api-services/user-appointment.service';
import { carrierAttributes } from 'models/carrierAttributes.model';
import { SharedService } from 'services';
import { ngbModalOptionsLG } from 'shared/constant';
import { AddAppointerPopupComponent } from '../add-appointer-popup/add-appointer-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RoleService } from 'services/role.service';
import { State } from 'models';
import { LinesOfAuthorityService } from 'api-services/lines-of-authority.service';

@Component({
  selector: 'app-appointer-information',
  templateUrl: './appointer-information.component.html',
  styleUrls: ['./appointer-information.component.css']
})
export class AppointerInformationComponent implements OnInit {
  @Input() selectedAppointmentWith;
  appointerInfo: carrierAttributes;
  loggedInTenantId = Number(this.sharedService.getKey('tenantId'));
  @Output() isCurrentPopupVisible: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() isAppointerAvailable: EventEmitter<boolean> = new EventEmitter<boolean>();
  isMGAUser: boolean = false;
  // isCurrentPopupVisible: boolean = true;
  masterStates: State[] = [] as State[];

  constructor(private appointmentService: UserAppointmentService, private loaService: LinesOfAuthorityService, private roleService: RoleService, private sharedService: SharedService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.loadMasterStates();
    this.isMGAUser = this.roleService.isMGAUser;
  }

   loadMasterStates() {
    this.loaService.getAllStates().subscribe(
      response => {
        this.masterStates = response;
        if(this.selectedAppointmentWith?.stateId && this.selectedAppointmentWith?.carrierId){
          this.getAppointerInfo();
        }else{
          this.appointerInfo = null;
        }
      }
    )
  }

  getAppointerInfo(){
    this.appointmentService.getCarrierDetailforAppointer(this.loggedInTenantId, this.selectedAppointmentWith.carrierId, this.selectedAppointmentWith.stateCode).subscribe(res => {
      this.appointerInfo = res;
     
      if(this.appointerInfo?.carrierAttributesId > 0){
        this.appointerInfo.appointerName =  this.appointerInfo.firstName+ ' ' +this.appointerInfo.lastName;
        this.appointerInfo['appStateNameWithStateCode'] = this.masterStates.find(el => el.stateName == this.appointerInfo.appointmentState)?.stateNameWithStateCode;
        this.appointerInfo['ResStateNameWithStateCode'] = this.masterStates.find(el => el.stateCode == this.appointerInfo.appointerResidenceStateCode)?.stateNameWithStateCode;
        // this.appointerInfo.stateId = this.selectedAppointmentWith.stateId;
        this.isAppointerAvailable.next(true);
      }
      else{
        this.isAppointerAvailable.next(false);
      }
    },err =>{
      this.isAppointerAvailable.next(false);
    });
  }
  
  ngOnChanges(changes: SimpleChange) {
    if(this.selectedAppointmentWith?.stateId && this.selectedAppointmentWith?.carrierId){
      this.masterStates ? this.getAppointerInfo() : this.ngOnInit();
    }else{
      this.appointerInfo = null;
    }
      
  }

    openAddAppointerPopup(){
    this.isCurrentPopupVisible.next(false);
    const modalRef = this.modalService.open(AddAppointerPopupComponent, ngbModalOptionsLG);
    modalRef.componentInstance.selectedAppointmentWith = this.appointerInfo;
    modalRef.result.then(data => {
      this.isCurrentPopupVisible.next(true);
      if (data) {
        this.getAppointerInfo();
      }
    });
  }

}
